import { Logger } from 'wdc-cube';
const LOG = Logger.get('Mormaii.Storage');
/**
 * O armazenamento local, que pode LANCAR e nao so devolver vazio.
 *
 * Aba privada, dados do site bloqueados, contexto sem permissao: nenhum desses e
 * motivo para a aplicacao nao subir. Estas tres funcoes moravam dentro do
 * `api-client.ts`, onde nasceram para guardar o token; saíram de la quando a casca
 * passou a lembrar a ultima empresa escolhida - dois consumidores nao precisam de
 * duas copias do mesmo `try/catch`.
 */
export function safeRead(key) {
    try {
        return localStorage.getItem(key);
    }
    catch {
        return null;
    }
}
export function safeWrite(key, value) {
    try {
        localStorage.setItem(key, value);
    }
    catch {
        LOG.warn(`Could not persist ${key}`);
    }
}
export function safeRemove(key) {
    try {
        localStorage.removeItem(key);
    }
    catch {
        /* nada a fazer */
    }
}
/**
 * O mesmo, na SESSAO da pagina: some ao fechar a aba.
 *
 * Para o que vale enquanto a pessoa esta trabalhando e nao deve atravessar para o dia
 * seguinte - o ultimo periodo escolhido (B-35).
 */
export function safeSessionRead(key) {
    try {
        return sessionStorage.getItem(key);
    }
    catch {
        return null;
    }
}
export function safeSessionWrite(key, value) {
    try {
        sessionStorage.setItem(key, value);
    }
    catch {
        LOG.warn(`Could not persist ${key} in the session`);
    }
}
//# sourceMappingURL=storage.js.map